export const sjxyxName = {
  PremiumHealthServices_sjxyx_first: '臻享健康服务plus小药箱',
  PremiumHealthServices_sjxyx_spring: '四季小药箱（春季）',
  PremiumHealthServices_sjxyx_summer: '四季小药箱（夏季）',
  PremiumHealthServices_sjxyx_autumn: '四季小药箱（秋季）',
  PremiumHealthServices_sjxyx_winter: '四季小药箱（冬季）',
};
